<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>处理任务</el-breadcrumb-item>
      <el-breadcrumb-item>任务领取</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card>
      <el-row :gutter="20">
        <el-col :span="8">
          <el-input
            placeholder="请输入内容"
            clearable
            v-model="queryInfo.query"
            @clear="handleCurrentChange(1);"
          >
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="
                handleCurrentChange(1);
                getDataList;
              "
            ></el-button>
          </el-input>
        </el-col>
        <!-- <el-col :span="4" :offset="12">
          <el-button
            type="primary"
            plain
            style="position:absolute;right:10px;"
            @click="gotoMyTasks"
          >我的任务列表</el-button>
        </el-col> -->
      </el-row>

      <el-table :data="datalist" stripe border style="width: 100%" v-loading="loading">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="data_id" label="数据编号"></el-table-column>
        <el-table-column prop="data_name" label="数据名称" width="160"></el-table-column>
        <el-table-column prop="age" label="年龄" width="80"></el-table-column>
        <el-table-column prop="data_dimen" label="数据维度" width="100"></el-table-column>
        <el-table-column prop="data_space" label="物理间距" width="200"></el-table-column>
        <el-table-column prop="coordinate" label="起点坐标" width="300"></el-table-column>
        <el-table-column prop="upload_user" label="上传用户" width="100"></el-table-column>
        <el-table-column label="上传时间" width="140">
          <template v-slot="scope">{{ scope.row.upload_time }}</template>
        </el-table-column>
        <el-table-column label="确认处理" width="100">
          <template v-slot="scope">
            <el-button size="mini" type="primary" @click="getTheTask(scope.row.data_id)">处理数据</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="queryInfo.pagenum"
        :page-sizes="[5, 15, 20]"
        :page-size="queryInfo.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      queryInfo: {
        query: "",
        pagenum: 1,
        pagesize: 5
      },
      datalist: [],
      total: 0
    };
  },
  methods: {
    async getDataList() {
      this.loading = true;
      const { data } = await this.$http.post("data/todolist", this.queryInfo);
      if (data.status === 100) {
        this.datalist = data.data.list;
        this.total = data.data.total;
        this.loading = false;
      }
    },
    handleSizeChange(newSize) {
      this.queryInfo.pagesize = newSize;
      this.queryInfo.pagenum = 1;
      this.getDataList();
    },
    handleCurrentChange(newPage) {
      this.queryInfo.pagenum = newPage;
      this.getDataList();
    },
    getTheTask(data_id) {
      this.$confirm("确认后由您负责该数据的分割工作", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      })
        .then(async () => {
          const { data } = await this.$http.post("data/gettask", {
            dataid: data_id
          });
          if (data.status === 100) {
            this.$message({
              type: "success",
              message: "已确认！请到我的任务列表查看"
            });
            this.queryInfo.pagenum = 1;
            this.getDataList();
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
    }
  },
  created() {
    this.getDataList();
  }
};
</script>

<style lang="less" scoped>
.el-cascader {
  width: 100%;
}
</style>
